export default {"src":"/_next/static/media/gray-heart-icon.1ca52980.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};